export const LOAD_SILO_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_SILO_WIDGET_DATA_REQUEST";
